export const PRODUCT_NAME = 'Ivy Clinicians';
export const IVY_LOGO = 'https://assets.ivyclinicians.io/logo/logo.svg';
export const IVY_LOGO_TOP = 'https://assets.ivyclinicians.io/logo/logo-top.svg';
export const IVY_LOGO_WHITE =
	'https://assets.ivyclinicians.io/logo/ivy-logo-white.svg';
export const IVY_INLINE_LOGO_WHITE =
	'https://assets.ivyclinicians.io/logo/logo-inline-white.svg';
